import { render, staticRenderFns } from "./HbNotification.vue?vue&type=template&id=66ab20b4&scoped=true&"
import script from "./HbNotification.vue?vue&type=script&lang=js&"
export * from "./HbNotification.vue?vue&type=script&lang=js&"
import style0 from "./HbNotification.vue?vue&type=style&index=0&id=66ab20b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ab20b4",
  null
  
)

export default component.exports